import React from 'react'
import { Card, Form, Input, Button, Checkbox, Row, Col, message } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import usecustomStyles from '../../Common/customStyles';
import ParticleAuth from '../../Common/ParticleAuth';
import styled from 'styled-components';
import { APIClient } from "../../helpers/api_helper";


const customStyles = usecustomStyles();
const api = new APIClient();
const StyleWrapper = styled.div`
    background-color: ${({ theme }) => theme.token.authbgcolor};
`

const PasswordCreate = () => {

    const { token } = useParams();  // take token from path
    const navigate = useNavigate();

    // page title
    document.title = "Ustvari geslo" + process.env.REACT_APP_PAGE_TITLE;

    const onFinish = async (values) => {
        try {
            const { password } = values;
            const payload = {password, token}

            // call backend API with password and token in payload
            api.post(`/api/auth/create_password/`, payload)
                .then(resp => {
                    console.log("RRR", resp)
                    message.success("Geslo je bilo uspešno nastavljeno");
                    navigate("/auth-signin");
                })
                .catch(error => {
                    console.log("INHERE", error.response.data.detail)
                    message.error(error.response.data.detail);
                })

        } catch (err) {
            message.error(err.response?.data?.message || "Nastavitev gesla ni uspela");
        }
    };

    return (
        <React.Fragment>
            <StyleWrapper className="auth-page-wrapper">
                <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
                    <Col xs={24} lg={14}>
                        <Card>
                        <Row gutter={[16, 24]}>
                                <ParticleAuth />
                                <Col xs={24} lg={14}>
                                    <Card style={{ border: "0px" }}>
                                        <div className="text-center mt-2" style={{ margin: "20px" }}>
                                            <h5 style={{ fontSize: "20px", color: customStyles.colorPrimary }}>Ustvari novo geslo</h5>
                                        </div>
                                        <div>
                                            <Form name="password-create-form" onFinish={onFinish} >
                                                <div>
                                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom:'4px' }}>
                                                        <label>Geslo</label>
                                                    </div>
                                                    <Form.Item
                                                        name="password"
                                                        hasFeedback
                                                        rules={[
                                                            { required: true, message: 'Prosimo, vnesite geslo' },
                                                            { pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/, message: 'Geslo mora vsebovati vsaj 1 številko, 1 veliko in 1 malo črko ter biti dolgo 8+ znakov' }
                                                        ]}
                                                    >
                                                        <Input.Password

                                                            placeholder="Vnesite geslo" style={{outline:'none', boxShadow:'none'}}
                                                        />
                                                    </Form.Item>
                                                    <div style={{ fontSize: "12px", marginTop:'4px', display:'block' }}>Geslo mora biti dolgo 8–20 znakov.</div>
                                                </div>

                                                <div>
                                                    <label style={{marginBottom:'4px', display:'block' }}>Potrdi geslo</label>
                                                    <Form.Item
                                                        name="confirmpassword"
                                                        hasFeedback
                                                        dependencies={['password']}
                                                        rules={[
                                                            { required: true, message: 'Potrdite geslo' },
                                                            ({ getFieldValue }) => ({
                                                                validator(_, value) {
                                                                    if (!value || getFieldValue('password') === value) {
                                                                        return Promise.resolve();
                                                                    }
                                                                    return Promise.reject(new Error('Gesli se ne ujemata!'));
                                                                },
                                                            }),
                                                        ]}
                                                    >
                                                        <Input.Password placeholder="Potrdite geslo" style={{outline:'none', boxShadow:'none'}} />
                                                    </Form.Item>
                                                </div>

                                                <Form.Item>
                                                    <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
                                                        Shrani novo geslo
                                                    </Button>
                                                </Form.Item>
                                            </Form>
                                        </div>
                                    </Card>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </StyleWrapper>
        </React.Fragment>
    )
}

export default PasswordCreate
